import { CaptionStyles, CaptionLineConfig } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const custom: Partial<CaptionStyles> = {
  pageStyle: undefined,
  wordStyle: undefined,
  letterStyle: undefined,
  theme_preset: 'custom',
  font_location: getFontFullPath('Bangers-Regular.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 102,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default custom;
